<template>
  <v-theme-provider dark>
    <base-section
      id="contact-us"
      class="primary"
      space="10"
    >
      <v-container>
        <v-row justify="center">
          <v-col cols="9">
            <base-title
              :space="$vuetify.breakpoint.mdAndUp ? 0 : 4"
              title=" ¡ CITATORIO  ASAMBLEA GENERAL 2024 !"
            />

            <base-body space="0">
              <span class="white--text">
                Se cita a la  Asamblea General de Asociados del Consejo Mexicano</br>
                 de Patología Clínica y Medicina de Laboratorio, A.C. Viernes 1 de Noviembre 2024</br>
              </span>
              <p class="white--text mt-2">
                Consulta los detalles  en el botón de VER CITATORIO
              </p>
            </base-body>
          </v-col>

          <v-col
            cols="12"
            md="3"
          >
            <!--<base-btn
              :block="$vuetify.breakpoint.smAndDown"
              color="white"
              large
              outlined
              :href="path_convocatoria_certificacion"
              target="_blank"
            >
              CONVOCATORIA CERTIFICACIÓN 2023
            </base-btn>-->

            <base-btn
              class="mt-2"
              :block="$vuetify.breakpoint.smAndDown"
              color="white"
              large
              outlined
              :href="path_convocatoria_recertificacion"
              target="_blank"
            >
              VER CITATORIO
            </base-btn>
          </v-col>
        </v-row>
      </v-container>
    </base-section>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'CitatorioAsamblea',
    data: () => ({
      //path_convocatoria_certificacion:process.env.VUE_APP_BASE_URL+'/convocatorias/2023/convocatoria_certificación_2023.pdf',
     //path_convocatoria_recertificacion:process.env.VUE_APP_BASE_URL+'/convocatorias/2023/convocatoria_recertificacion_2023B.pdf',
      //path_convocatoria_recertificacion:process.env.VUE_APP_BASE_URL+'/citatorios/citatorio_a_primer_asamblea_general_2023.pdf',
      path_convocatoria_recertificacion:process.env.VUE_APP_BASE_URL+'/citatorios/Citatorio a Asamblea General 2024.pdf',


    }),
    methods:{

    }
  }
</script>
